import { DataGrid, esES } from '@mui/x-data-grid';
import { Box, Tooltip } from '@mui/material';
import './EscoDataGrid.css';

const getStatusColor = (status) => {
    switch (status) {
      case 0: //'Procesando'
        return '🟡';
      case 1: //'OK'
        return '🟢';      
      case 2: //'Error'
        return '🔴';
      default:
        return '⚫';
    }
  };  


function EscoStatusGrid({ columns, data }) {
    // Transformar datos para asegurar compatibilidad con DataGrid
    const rows = data?.spTablero_GetTablaDeActividades_Result?.map((activity, index) => ({
      id: activity.IdAppProcedimientos ?? index,
      descripcion: activity.DescripcionProcedimiento,
      fechaInicio: activity.FechaInicio,
      fechaFin: activity.FechaFin ?? '-',
      fechaError: activity.FechaError ?? '-',
      mensaje: activity.Mensaje,
      estado: getStatusColor(activity.Semaforo)
  })) ?? [];
  

    return (
        <Box sx={{ height: 600, width: '100%' }}>
            <DataGrid
                sx={{ m: 2 }}
                rows={rows}
                columns={columns}
                autoHeight
                disableColumnResize={false}
                localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                // loading={loading}
                density='compact'
            />
        </Box>
    );
}

export default EscoStatusGrid;
